import { Injectable } from '@angular/core';

declare let FS: any;

@Injectable({
  providedIn: 'root',
})
export class FullstoryService {

  constructor() {}
  identifyUser(userId: string, properties: Record<string, any> = {}): void {

    if (typeof FS !== 'undefined') {
      FS('setIdentity', {
        uid: userId,
        properties
      });
      FS('event', 'LoginSuccess');
    }
  }

}
